var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { SystemIcon } from '@storeblocks/icon';
function Icon({ checked, indeterminate, disabled }) {
    return (React.createElement(IconBase, { checked: checked, indeterminate: indeterminate, "aria-disabled": disabled },
        !checked && React.createElement(SystemIcon, { name: "selection-controls-unchecked", size: 16 }),
        checked && React.createElement(SystemIcon, { name: "selection-controls-checked", size: 16 }),
        indeterminate && (React.createElement(SystemIcon, { name: "selection-controls-indeterminate", size: 16 }))));
}
export const IconBase = styled.div `
  display: flex;
  align-items: center;

  flex-shrink: 0;

  width: 16px;
  height: 16px;

  margin: 16px 16px 16px 0;

  background: var(--color-background);

  /* border-radius: 2px; */
  /* border: 2px solid var(--color-on-background); */
  box-sizing: border-box;

  & > i {
    color: var(--color-selection);
  }
  /*
  ${({ checked, indeterminate }) => (checked || indeterminate) &&
    css `
      border-color: var(--color-selection);
      background: var(--color-selection);
    `} */

  ${(_a) => {
    var props = __rest(_a, []);
    return props['aria-disabled'] &&
        css `
      & > i {
        color: var(--color-disabled);
      }
    `;
}}
`;
export default Icon;
